import { ImageSize, LogoSize } from '../../../enums/imageSizes.ts';
import { buildImagePath } from '../../../helpers/buildImagePath.ts';
import { type Config } from '../../../types.ts';

export const formatAvatarPath = (avatarPath: string | null | undefined, images: Config['images']) => {
  if (avatarPath) {
    if (avatarPath.startsWith('http')) {
      return avatarPath;
    }

    if (avatarPath.startsWith('/http')) {
      return avatarPath.slice(1);
    }
  }

  return buildImagePath(avatarPath, ImageSize.Logo, LogoSize.XS, images);
};
